import { render } from "./freshAirFan.vue?vue&type=template&id=45589132&scoped=true"
import script from "./freshAirFan.vue?vue&type=script&lang=js"
export * from "./freshAirFan.vue?vue&type=script&lang=js"

import "./freshAirFan.vue?vue&type=style&index=0&id=45589132&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45589132"]])

export default __exports__